/*!

=========================================================
* Paper Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.2.0";
import "assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";

import AdminLayout from "layouts/Admin.js";
import LoginLayout from "layouts/Login.js";

const hist = createBrowserHistory();

function getDefaultRoute() {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user?.role === 'ADMIN') return '/dashboard';
    if (user) return '/orders-id';
    return '/login';
  } catch {
    return '/login';
  }
}

ReactDOM.render(
  <Router history={hist}>
    <Switch>
      <Route path="/login" component={LoginLayout} />
      <Route path="/" render={(props) => <AdminLayout {...props} />} />
      <Redirect to={getDefaultRoute()} />
    </Switch>
  </Router>,
  document.getElementById("root")
);
